import dayjs from "dayjs";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";

export const FONT = "THSarabunNew";
export const NAVY = [31, 58, 95];
export const ML = 14;

export const thb = (n) =>
  Number(n || 0).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// แสดงวันที่ (รับ dayjs / Date / ISO string)
export const fmtD = (d) => (d ? dayjs(d).format("DD/MM/YYYY") : "-");

export function drawSectionTitle(doc, x, y, w, title) {
  doc.setFont(FONT, "bold");
  doc.setFontSize(17);
  doc.setTextColor(0, 0, 0);
  doc.text(title, x, y);
  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.3);
  doc.line(x, y + 2, x + w, y + 2);
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  return y + 7;
}

export function drawField(doc, x, y, label, value) {
  doc.setFont(FONT, "bold");
  doc.setFontSize(14);
  doc.text(label + ":", x, y);
  const lw = doc.getTextWidth(label + ":");
  doc.setFont(FONT, "normal");
  doc.text(String(value ?? "-"), x + lw + 2, y);
  return y + 8;
}

// ขึ้นหน้าใหม่ถ้าพื้นที่เหลือไม่พอสำหรับเนื้อหาถัดไป
export function ensureSpace(doc, y, needed = 40) {
  const pageH = doc.internal.pageSize.getHeight();
  if (y + needed > pageH - 10) {
    doc.addPage();
    return 16;
  }
  return y;
}

// แปลง due_date รูปแบบ MM-DD-YY → dayjs
export const parseDue = (s) => {
  if (!s) return null;
  const [mm, dd, yy] = s.split("-");
  const d = dayjs(`20${yy}-${mm}-${dd}`);
  return d.isValid() ? d : null;
};

// due_date ล่าสุดในรายการ overdue ของบัญชี
export const latestDueDate = (overdue = []) => {
  let max = null;
  for (const o of overdue) {
    const d = parseDue(o.due_date);
    if (d && (!max || d.isAfter(max))) max = d;
  }
  return max;
};

// วันเริ่มคิดดอกเบี้ย = due_date ล่าสุด + 1 เดือน
export const interestStart = (overdue = []) => {
  const last = latestDueDate(overdue);
  return last ? last.add(1, "month") : null;
};

// อัตราดอกเบี้ย ONE เริ่มต้น
export const DEFAULT_INTEREST_RATE = 0.15;

// วันเริ่มคิดดอกเบี้ยที่ใช้จริง = วันที่ผู้ใช้เลือก (ถ้ามี) หรือค่าเริ่มต้น แต่ไม่ต่ำกว่า due_date ล่าสุด
export const resolveStart = (overdue = [], startDate) => {
  const start = startDate ? dayjs(startDate) : interestStart(overdue);
  const min = latestDueDate(overdue);
  if (!start) return min;
  return min && start.isBefore(min, "day") ? min : start;
};

// จำนวนวันจากวันเริ่ม (start) ถึงวันที่คิดดอกเบี้ย (asOf)
export const daysFrom = (start, asOf) => {
  if (!start) return 0;
  const end = asOf ? dayjs(asOf) : dayjs();
  const days = end.diff(dayjs(start), "day");
  return days > 0 ? days : 0;
};

// ดอกเบี้ย ONE = เงินต้น * rate (ค่าเริ่มต้น 15%) * จำนวนวันจาก start ถึง asOf / 365
export const calcInterest = (
  principal,
  start,
  asOf,
  rate = DEFAULT_INTEREST_RATE,
) => {
  if (!principal) return 0;
  return (Number(principal) * rate * daysFrom(start, asOf)) / 365;
};
